import { sortBy } from 'lodash';

export default {
  getMapItem: (state) => state.mapItem,
  sortedMapItems: (state) => sortBy(state.mapItems, (m) => m.name),
};
